export default () => {
  return inject<() => Record<string, number>>('mods', () => ({}))
}
